// extracted by mini-css-extract-plugin
export default {"box":"Cities_box__LY9AJ"};